import { Controller } from "@hotwired/stimulus";

export default class MatchSelectorController extends Controller<HTMLFormElement> {
  selectMatch() {
    this.element.requestSubmit();
  }
}
